export default __webpack_public_path__ + "static/media/3.9c4d6c37.jpg";